// extracted by mini-css-extract-plugin
module.exports = {"main":"Notifications_main__11Ut5","box":"Notifications_box__3Pjfs"};